import { Observable } from "rxjs";
import { Job, MasterPlan, Plan } from "../domain/models/master-plan";
import { BindLocationWithJobRequest, GetPlansByMasterPlanAndLocationIdRequest, GetPlansByMasterPlanAndSegmentRequest, MasterPlanByLocationProductIdRequest, MasterPlansRequest } from "../domain/requests";
import { Injectable } from "@angular/core";

@Injectable({providedIn: 'root'})
export abstract class PlanningPortalRepository {
    abstract GetMasterPlanForMLS(segment: MasterPlansRequest): Observable<MasterPlan[]>;
    abstract getMasterPlanByLocationIdAndProductId(request: MasterPlanByLocationProductIdRequest): Observable<MasterPlan[]>;
    abstract addLocationWithJob(request: BindLocationWithJobRequest[]): Observable<boolean>;
    abstract GetPlansByMasterPlanAndSegment(request: GetPlansByMasterPlanAndSegmentRequest): Observable<Job[]>;
    abstract GetPlansByMasterPlanAndLocationId(request: GetPlansByMasterPlanAndLocationIdRequest): Observable<Job[]>;
  }
  